import { doc, updateDoc, arrayUnion, Timestamp, getDoc } from 'firebase/firestore';
import { db } from '../config';
import type { UserRole, UserRoleAssignment } from '@/types';

export async function addUserRole(userId: string, role: UserRole, assignedBy: string) {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      throw new Error('User not found');
    }

    const userData = userDoc.data();
    const roles = userData.roles || [];
    
    // Check if role already exists
    const existingRole = roles.find((r: UserRoleAssignment) => r.role === role);
    
    if (existingRole) {
      // Update existing role to active
      const updatedRoles = roles.map((r: UserRoleAssignment) => 
        r.role === role ? { ...r, isActive: true } : r
      );
      await updateDoc(userRef, { roles: updatedRoles });
    } else {
      // Add new role
      const newRole = {
        role,
        assignedAt: Timestamp.now(),
        assignedBy,
        isActive: true
      };
      await updateDoc(userRef, {
        roles: arrayUnion(newRole)
      });
    }

    return true;
  } catch (error) {
    console.error('Error updating roles:', error);
    throw error;
  }
}

export async function deactivateUserRole(userId: string, role: UserRole) {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      throw new Error('User not found');
    }

    const userData = userDoc.data();
    const updatedRoles = userData.roles.map((r: UserRoleAssignment) => 
      r.role === role ? { ...r, isActive: false } : r
    );

    await updateDoc(userRef, { roles: updatedRoles });
    return true;
  } catch (error) {
    console.error('Error deactivating role:', error);
    throw error;
  }
}